<script lang="ts" setup>
  import type { NavLink } from '@layouts/types';

  import { useLayouts } from '@layouts';
  import { config } from '@layouts/config';
  import { can } from '@layouts/plugins/casl';
  import { getComputedNavLinkToProp, isNavLinkActive } from '@layouts/utils';

  defineProps<{
    item: NavLink;
  }>();

  const { width: windowWidth } = useWindowSize();
  const { isVerticalNavMini } = useLayouts();

  const hideTitleAndBadge = isVerticalNavMini(windowWidth);
</script>

<template>
  <li v-if="can(item.action, item.subject)" class="nav-link" :class="{ disabled: item.disable }">
    <Component
      :is="item.to ? 'RouterLink' : 'a'"
      v-bind="getComputedNavLinkToProp(item)"
      :class="{ 'router-link-active router-link-exact-active': isNavLinkActive(item, $router) }"
    >
      <Component
        :is="config.app.iconRenderer || 'div'"
        v-bind="item.icon || config.verticalNav.defaultNavItemIconProps"
        class="nav-item-icon"
      />
      <TransitionGroup name="transition-slide-x">
        <Component is="span" v-show="!hideTitleAndBadge" key="title" class="nav-item-title">
          {{ item.title }}
        </Component>

        <Component
          is="span"
          v-if="item.badgeContent"
          v-show="!hideTitleAndBadge"
          key="badge"
          class="nav-item-badge"
          :class="item.badgeClass"
        >
          {{ item.badgeContent }}
        </Component>
      </TransitionGroup>
    </Component>
  </li>
</template>

<style lang="scss">
  .layout-vertical-nav {
    .nav-link a {
      display: flex;
      align-items: center;
    }
  }
</style>
